import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cog, Flame, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function AdminDevTrackCard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin-dev/track/me").then((res) => setStats(res.data)).catch(() => {});
  }, []);

  const pct = stats ? Math.round((stats.days_completed / stats.total_days) * 100) : 0;

  return (
    <Link
      to="/admin-dev"
      data-testid="dashboard-admin-dev-track-card"
      className="group relative rounded-[18px] border border-[#232d42] bg-[#131a29] p-5 pt-6 block transition-all duration-300 hover:-translate-y-1 hover:border-[#f59e0b]/60 hover:shadow-[0_12px_40px_rgba(245,158,11,0.15)] overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-[3px] bg-[#f59e0b]" />
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Cog className="w-4 h-4 text-[#f59e0b]" />
          <span className="text-xs font-bold uppercase tracking-wider text-[#f59e0b]">Admin + Dev Track</span>
        </div>
        {stats && stats.streak_current > 0 && (
          <span className="flex items-center gap-1 text-[11px] font-bold font-mono text-[#f59e0b]" data-testid="dashboard-admin-dev-streak">
            <Flame className="w-3 h-3" /> {stats.streak_current}
          </span>
        )}
      </div>
      <p className="text-sm font-semibold text-[#eef1f8]">Salesforce Admin + Dev 30-Day Challenge</p>
      <p className="text-xs text-[#8993ab] mt-1">Data Model, Security & Automation, then Apex, Triggers & Integration</p>
      <div className="w-full h-1.5 bg-[#1b2434] rounded-full overflow-hidden mt-4">
        <div className="h-full bg-[#f59e0b] rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
      </div>
      <div className="flex items-center justify-between mt-2">
        <span className="text-[11px] font-mono text-[#8993ab]">{stats ? `${stats.days_completed}/${stats.total_days} days` : "Loading..."}</span>
        <span className="text-[11px] font-semibold text-[#f59e0b] flex items-center gap-1 group-hover:gap-1.5 transition-all">
          {stats?.days_completed > 0 ? "Continue" : "Start"} <ArrowRight className="w-3 h-3" />
        </span>
      </div>
    </Link>
  );
}
